(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meccha-cart"]) return;
  try {
    
  (function () {
    var form = document.getElementById('mc-cartpage-form');
    if (!form) return;
    form.querySelectorAll('.mc-cartpage__qbtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.mc-cartpage__qinput');
        var step = parseInt(btn.getAttribute('data-step'), 10);
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        form.submit();
      });
    });
    form.querySelectorAll('.mc-cartpage__qinput').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meccha-category-sliders"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mc-cs__row').forEach(function (row) {
      var track = row.querySelector('.mc-cs__track');
      if (!track) return;
      row.querySelectorAll('.mc-cs__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
          var amount = Math.max(track.clientWidth * 0.85, 280);
          track.scrollBy({ left: dir * amount, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meccha-collection"]) return;
  try {
    
  (function () {
    // Category chips are now links to their collections; only the sort control needs JS.
    var sel = document.getElementById('mc-coll-sortsel');
    if (sel) { sel.addEventListener('change', function () { document.getElementById('mc-coll-sort').submit(); }); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meccha-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fill(bar) {
      var track = bar.querySelector('[data-mc-marquee-track]');
      if (!track) return;
      var groups = track.querySelectorAll('[data-mc-marquee-group]');
      if (!groups.length) return;
      var vw = Math.max(window.innerWidth, 320);
      // repeat the content inside each (identical) group until one group is wider than the viewport,
      // so at -50% the scroll is always fully covered — no empty gap
      groups.forEach(function (g) {
        if (!g.dataset.base) g.dataset.base = g.innerHTML;
        else g.innerHTML = g.dataset.base;
        var guard = 0;
        while (g.offsetWidth < vw + 60 && guard < 12) { g.innerHTML += g.dataset.base; guard++; }
      });
      // constant speed regardless of how much we repeated
      var speed = parseFloat(bar.dataset.speed) || 28;      // seconds to cross ~ a 1000px group
      var groupW = groups[0].offsetWidth;
      var dur = (groupW / 1000) * speed;
      track.style.setProperty('--mc-marquee-dur', dur.toFixed(1) + 's');
    }
    document.querySelectorAll('[data-mc-marquee]').forEach(fill);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { document.querySelectorAll('[data-mc-marquee]').forEach(fill); }, 250); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meccha-product"]) return;
  try {
    
  (function () {
    var form = document.getElementById('mc-pdp-form');
    if (!form) return;

    var qtyInput = form.querySelector('.mc-pdp__qty-input');
    form.querySelectorAll('.mc-pdp__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      });
    });

    var variant = document.getElementById('mc-pdp-variant');
    if (variant) {
      variant.addEventListener('change', function () {
        var price = variant.options[variant.selectedIndex].getAttribute('data-price');
        var priceEl = document.getElementById('mc-pdp-price');
        if (price && priceEl) priceEl.textContent = price;
        if (price) { document.querySelectorAll('.mc-pdp__atc-price').forEach(function (el) { el.textContent = price; }); }
      });
    }

    var mainImg = document.getElementById('mc-pdp-main-img');
    document.querySelectorAll('.mc-pdp__thumb[data-full]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        document.querySelectorAll('.mc-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var bar = document.getElementById('mc-pdp-stickybar');
    var buyRow = form.querySelector('.mc-pdp__buy');
    if (bar && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(buyRow);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
